export default __webpack_public_path__ + "static/tetragon-shield-9b9d3b1f08397c40c37a12f8e5b442b0.png";